import React, { Component } from "react";
import { connect } from "react-redux";
import tracking from "@/utils/tracking";
import FlexibleHeader from "@/components/organisms/FlexibleHeader";
import Newsletter from "@/components/organisms/Newsletter";
import EventsList from "@/components/organisms/lists/EventsList";
import ArticlesList from "@/components/organisms/lists/ArticlesList";
import MetaDetail from "@/components/atoms/MetaDetail";
import {
	fetchPageData,
	fetchComponentData
} from "@/services/contentEvents/actions";
import { keyFromPath } from "@/utils/dataFormatting";

import "./generic.scss";
import EventsBanner from "../../components/EventsBanner";

class Generic extends Component {
	featureIndex = -1;
	componentDataLoadInit = false;

	componentDidMount() {
		if (!this.props.pageData) {
			this.props.fetchPageData(this.props.apiPath, this.props.pageID);
		}

		tracking.pageView(this.props.routeProps.location.pathname);
		window.scrollTo(0, 0);
	}

	componentDidUpdate() {
		if (
			this.props.pageData &&
			!this.props.moduleComponentData &&
			!this.componentDataLoadInit
		) {
			// Prevents loading twice, in case of quick updates in succession
			// before first data fetch has finished
			this.componentDataLoadInit = true;

			const componentEndpoints = this.props.pageData.map(item => {
				return item.pagecomponent;
			});

			if (this.props.pageID === "pageEventsList") {
				console.log('gen componentEndpoints: ', componentEndpoints);
				// componentEndpoints.splice(2, 0, `${process.env.PREACT_APP_CONTENT_URI}/summer-garden.json?v=${Math.random()}`);
			}

			let index = 0;
			componentEndpoints.forEach(url => {
				this.props.fetchComponentData(url, this.props.pageID, index);
				index++;
			});
		}
	}

	returnComponent({ data, id }) {
		switch (data.type) {
			case "Page-Component__Meta-Data":
				return <MetaDetail data={data.content} metaDescription="test"/>;
			case "Page-Component__Flexible-Header":
				return <FlexibleHeader data={data.content} imageAlt="The Guinness Open Gate Brewery offers a vibrant summer garden in the heart of Dublin 8." />;
			// case "summer-garden":
			// 	return <EventsBanner data={data.content} />;
			case "Page-Component__Event-listing":
				return (
					<EventsList
						data={data.content}
						dataKey={keyFromPath(data.content.datasource)}
					/>
				);
			case "Page-Component__Article-listing":
				return <ArticlesList data={data.content} />;
			case "Page-Component__Banner-CTA":
				return (
					<Newsletter
						content={data.content}
						formData={this.props.componentData.signUpForm}
						fetchData={this.props.fetchData}
						routeProps={this.props.routeProps}
					/>
				);
			default:
				return null;
		}
	}

	renderComponents() {
		if (!this.props.moduleComponentData) {
			return null;
		}

		return this.props.moduleComponentData
			.filter(data => data !== undefined)
			.map(data => {
				return this.returnComponent(data);
			});
	}

	render() {
		console.log('gen props: ', this.props);
		return (
			<div className={this.props.className}>{this.renderComponents()}</div>
		);
	}
}

const sortComponentData = data => {
	if (!data) {
		return data;
	}
	const arr = data.slice();
	arr.sort((a, b) => {
		return a.id - b.id;
	});
	return arr;
};

const mapStateToProps = (state, ownProps) => {
	return {
		pageData: state.pageContent.pageData[ownProps.pageID],
		moduleComponentData: sortComponentData(
			state.pageContent.moduleComponentData[ownProps.pageID]
		)
	};
};

export default connect(
	mapStateToProps,
	{ fetchPageData, fetchComponentData }
)(Generic);



// WEBPACK FOOTER //
// ./src/pages/generic/index.js